import { StorageObjectType } from '../enums/StorageFileType.enum';
import MetaFileLink from 'src/app/models/metaFileLink.model';
import { StorageObjectPermissionReqRes } from './StorageObjectPermissionReqRes.model';
import { FilestackStatus } from '../enums/filestack-status.enum';

export class StorageObjectReqRes {
  public id: number;
  public displayName: string;
  public extension: string;
  public description: string;
  public filestackHandle: string;
  public filestackPolicy: string;
  public filestackSignature: string;
  public filestackUrl: string;
  public filestackSource: string;
  public filestackStatus: FilestackStatus;
  public storageObjectParentId: number;
  public clientDetailsId: number;
  public storageObjectType: StorageObjectType;
  public metaFileLinkId: number;
  public metaFileLink: MetaFileLink;
  public isPublic: boolean;
  public storageObjectPermissions: StorageObjectPermissionReqRes[];
  public createTimestamp: Date;
  public isDeleted: boolean;
  public sasContainerToken: string;
  public sessionId?: string;
}

export class HoldingStorageObjectReqRes extends StorageObjectReqRes {
  public holdingId: number;
}

// tslint:disable-next-line:no-namespace
export namespace StorageObjectReqRes {
  export function getFilestackUrlWithCredentials(storageObject: StorageObjectReqRes): string {
    if (!storageObject.filestackUrl) {
      return null;
    }
    if (storageObject.filestackPolicy && storageObject.filestackSignature) {
      return `${storageObject.filestackUrl}?policy=${storageObject.filestackPolicy}&signature=${storageObject.filestackSignature}`;
    }
    return storageObject.filestackUrl;
  }
}
